// removed by extract-text-webpack-plugin
module.exports = {"content-left-hand-setting":"content-left-hand-setting","contentLeftHandSetting":"content-left-hand-setting"};


//////////////////
// WEBPACK FOOTER
// ./src/components/saml/style.scss
// module id = 1455
// module chunks = 0